class o extends HTMLElement {
  constructor() {
    super(), this._handlePointerEnter = () => {
      this.isParentFocused || this._refreshImage();
    };
    const t = this.querySelector("img");
    t && (this._shadowRoot = this.attachShadow({ mode: "open" }), this._shadowRoot.innerHTML = this._getHTML(), this._replaceImageWithCanvas(t), this._initListeners());
  }
  get isParentFocused() {
    var t;
    return !!document.activeElement && document.activeElement !== document.body && ((t = document.activeElement) == null ? void 0 : t.contains(this));
  }
  _getHTML() {
    return `
      <style>
        
  :host {
    display: inline-block;
    position: relative;
    width: fit-content;
  }

  slot::slotted(img) {
    min-height: 100%;
    width: 100%;
  }

  canvas {
    aspect-ratio: 2;
    left: 0;
    min-height: 100%;
    object-fit: fill;
    padding: 0;
    position: absolute;
    transition: opacity .2s;
    top: 0;
    width: 100%;
  }

  :host(:hover) canvas {
    opacity: 0;
  }

  @media (prefers-reduced-motion) {
    :host(:hover) canvas {
      visibility: visible;
    }
  }

      </style>
      <slot></slot>
    `;
  }
  _initListeners() {
    this.addEventListener("pointerenter", this._handlePointerEnter);
  }
  _waitForImageLoad(t) {
    return new Promise((e) => {
      if (t.complete) return e();
      t.addEventListener("load", () => e(), { once: !0 });
    });
  }
  _createCanvas(t) {
    const e = document.createElement("canvas");
    e.setAttribute("aria-hidden", "true"), e.setAttribute("part", "frozen");
    const n = t.height * window.devicePixelRatio, i = t.width * window.devicePixelRatio;
    e.width = i, e.height = n;
    const s = e.getContext("2d");
    s && (s.drawImage(t, 0, 0, i, n), this._shadowRoot.appendChild(e));
  }
  _replaceImageWithCanvas(t) {
    this._waitForImageLoad(t).then(() => {
      this._refreshImage(() => {
        this._createCanvas(t);
      });
    });
  }
  _refreshImage(t) {
    const e = this.querySelector("img");
    e && (t && e.addEventListener("load", t, { once: !0 }), e.setAttribute("src", e.src));
  }
}
customElements.define("af-frozen-img", o);
//# sourceMappingURL=FrozenImg.js.map
